import type { AxiosRequestConfig } from 'axios';

const useApiFetch = () => {
  const { $api } = useNuxtApp();

  const fetch: <T>(config: AxiosRequestConfig, returnResponse?: boolean) => Promise<T> = (config) => {
    const url = config.url as string;

    const extraHeaders =
      config.headers && typeof config.headers === 'object' && !Array.isArray(config.headers)
        ? (config.headers as Record<string, string>)
        : {};

    return $api(url, {
      method: config.method as any,
      body: config.data,
      headers: {
        'Content-Type': 'application/json',
        ...extraHeaders,
      },
      params: config.params,
      ...(config.baseURL ? { baseURL: config.baseURL } : {}),
    });
  };

  return {
    fetch,
  };
};
export default useApiFetch;
